import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "698ee21d-b1dc-4eaf-9743-8414cd2ca10e", content: "Coil length", options: {} },
  { id: "3cce690b-3ae3-4a28-a68d-11f5fc1bad41", content: "Magnetic field", options: {} },
  { id: "95afde19-9669-4fee-8a5c-900d04be69bd", content: "Diaphragm area", options: {} },
  { id: "2f6d6096-92ee-4bdc-a7e3-7500f443503c", content: "Diaphragm mass", options: {} },
  { id: "add9ff1d-8c52-4f95-99cd-846d6769f11c", content: "Diaphragm compliance", options: {} },
  { id: "7097005c-3362-42c6-90a0-e80990e3aebe", content: "Diaphragm damping", options: {} },
];

export const task: Task = {
  id: "17b026c0-ef01-4124-8628-26cb314e310a",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "698ee21d-b1dc-4eaf-9743-8414cd2ca10e",
    "3cce690b-3ae3-4a28-a68d-11f5fc1bad41",
    "95afde19-9669-4fee-8a5c-900d04be69bd",
    "2f6d6096-92ee-4bdc-a7e3-7500f443503c",
  ],
};
